import React, { memo } from 'react';
import type { ReactNode } from 'react';
import type { FunctionComponent } from 'react';
import useAuthProvider from './useAuthProvider';
import { Loader } from '@shared-components';
import { AuthStates } from './useAuthProvider';

interface AuthProps {
	children?: ReactNode;
}
const Auth: FunctionComponent<AuthProps> = ({ children }) => {
	const appState = useAuthProvider();
	return appState === AuthStates.LOADING ? <Loader fullscreen={true} /> : <>{children}</>;
};

export default memo(Auth);
